import { SITE_URL } from '@/lib/site';
export const COMPANY = {
  name: 'Willow Interiors',
  shortName: 'Willow',
  founded: 2021,
  tagline: 'Interior Design. Manufacturing. Execution.',
  description:
    'Willow Interiors is an interior design studio and manufacturing company based in Bengaluru. We design, manufacture and execute interior projects — with our own production capability.',
  address: {
    street: '198, 3rd Main Rd, next to Vision Sports Club, off Kanakapura Main Road',
    area: 'Narayana Nagar 2nd Block',
    city: 'Bengaluru',
    state: 'Karnataka',
    pincode: '560062',
    country: 'India',
    full: '198, 3rd Main Rd, next to Vision Sports Club, off Kanakapura Main Road, Narayana Nagar 2nd Block, Bengaluru, Karnataka 560062',
  },
  phone: {
    display: '077955 87910',
    tel: '+917795587910',
  },
  // Same number for calls and WhatsApp: 077955 87910 — confirmed by owner 08-Oct-2026 (82910 was a mistake).
  // Every WhatsApp link on the site is built from here — never type the number into a page.
  whatsapp: {
    number: '917795587910',
    display: '077955 87910',
    url: 'https://wa.me/917795587910',
    message: 'https://wa.me/917795587910?text=Hi%2C%20I%20would%20like%20to%20discuss%20an%20interior%20project.',
  },
  email: 'willowinterio@gmail.com',
  website: `${SITE_URL}`,
  market: 'Bengaluru, Karnataka, India',
  audiences: [
    'Homeowners',
    'Interior Designers',
    'Architects',
    'Builders',
    'NRI Clients',
  ],
} as const;